__turbopack_context__.v({
  "container": "ErrorBoundary-module-scss-module__EMwU5a__container",
  "icon": "ErrorBoundary-module-scss-module__EMwU5a__icon",
  "message": "ErrorBoundary-module-scss-module__EMwU5a__message",
  "title": "ErrorBoundary-module-scss-module__EMwU5a__title",
});
